<template>
  <div>
    <div class="main-add-services">
    </div>
    <div class="col-xs-12 pl-0 pr-10 main-services">
    <div v-if="!updateServiceFlag" class="col-sm-12 col-xs-12 col-md-12 box-wrapper">
      <hr class="upper-line" />
      <div class="row m-0">
        <div class="col-xs-12 col-sm-12 col-md-12 my-services">
           {{ $t('myServices')}}
        </div>
      </div>
      <div class="row m-0">
        <div class="col-xs-12 col-sm-12 col-md-12 my-services-account">
           {{ $t('account')}}
        </div>
      </div>
      <hr class="lower-line" />
      <div>
        <div class="row m-0">
          <div class="col-lg-7 col-md-8 col-sm-7 col-xs-6 team-members">
            <div class="col-xs-12 pl-0" :class="{'col-md-5 col-lg-5': restrictedUsersCount > 0}">
            <div class="team-member-reg"> {{ $t('teamMembers')}}</div>
           <div class="records-available" v-if="Object.keys(teamMember).length">
              <span >
                <span class="available-item" v-if="isREP"
                >{{(teamMember.current_utilization - 1) >= teamLimit ? 0 : teamLimit - (teamMember.current_utilization - 1)}} of {{teamLimit}}</span>
                <span v-else-if="purchaseDetails" ><span class="team-member-limit">{{ (purchaseDetails?teamLimit-purchaseDetails.currentUtilized : 0)}}</span><span class="available-item"> {{ $t('membersAddedLabel')}} </span></span>
                <span v-else ><span class="team-member-limit">{{ (teamMember.current_utilization) >= teamLimit ? 0 : teamLimit - (teamMember.current_utilization)}}</span><span class="available-item"> {{ $t('membersAddedLabel')}} </span></span>
              </span>
            </div>
            </div>
            <div class="col-md-7 col-lg-7 col-xs-12 pl-0 display-flex hidden-xs ft-16" v-if="restrictedUsersCount > 0">
              <div class="alert-image">
                <span class="tooltiptext">Your Team Member upgrade has expired. Every Conformity Declaration Management account can have up to 5 free users. Navigate to your team list to unblock up to 4 additional team members. For 5+ member access, upgrade your account at any time from the Services page under Account Settings.</span>
              </div>
              <span>Your Account has <br/> restricted team members</span>
            </div>
            <!-- <div class="col-xs-12 pl-0 free-renews" v-if="teamMember.total_limit > teamMember.default_limit">
              <span class="expiration-title"  v-if="teamMember.expiry_date">
                <img class="traingle-alert" src="/static/images/icons/alert_triangle.svg" />
                <b>Expires</b> {{teamMember.expiry_date | dateFormat }}
              </span>
              <span v-else>
                <span>Renews</span>
                {{ teamMember.valid_until | dateFormat }}
              </span>
            </div> -->
          </div>
        </div>
      </div>
      <div v-if="subscriptions.filter(obj => obj.subscriptionId === 2).length > 0">
       <div class="row m-0">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-4 services">{{ $t('services')}}</div>
      </div>
        <hr class="services-line" />
      <div class="row m-0 pb-100">
            <div class="col-xs-8 complianceTracker">
              <div class="col-xs-8 col-sm-8 col-md-8 pl-10 greenCheckMark">
                <img src="/static/images/icons/green_circle_check.svg" alt="" class="img">
                <h4 class="complianceTrackerText">{{ $t('proServices') }}</h4>
              </div>
            </div>
            <!-- <div class="col-xs-4" v-if="((subscriptions.filter(obj => obj.subscriptionId === 2).length > 0) && (subscriptions.filter(obj => obj.subscriptionId === 2)[0].isActive === true) && (roleId === 1 || roleId === roleInfo['Super Admin']))">
              <div class="cancel-sub" @click="cancelSubscription()">
                {{ $t('cancelSubscription') }}
              </div>
            </div> -->
            <div class="col-xs-4" v-if="((subscriptions.filter(obj => obj.subscriptionId === 2).length > 0) && (subscriptions.filter(obj => obj.subscriptionId === 2)[0].isActive === false) && (roleId === 1 || roleId === roleInfo['Super Admin']))">
              <div class="cancel-sub" @click="renewSubscription()">
                {{ $t('renewSubscription') }}
              </div>
            </div>
          </div>
          <hr class="services-line" />
    <div class="col-xs-12 text-center fnt_14 pb-24 pt-16">
      {{this.$i18n.locale === 'Portuguese'?'Para processo de cancelamento entre em contato':'For cancellation process please contact'}} <span class="help-text">CDMHelp@ul.com</span>
    </div>
          </div>
    </div>
  </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <template v-if="updateServiceFlag">
      <update-service @cancelUpdateAccount="cancelUpdateAccount" :current_utilization = teamMember.current_utilization :purchaseDetails="purchaseDetails" :roleId="roleId"></update-service>
    </template>
    <warning-popup
      :warningPopupId="warningPopupId"
      :confirmMessage="confirmMessage"
      :customMessage="customMessage"
      :productMessage="productMessage"
      :products="pendingProducts"
      @confirmCancel="confirmCancel()"
    ></warning-popup>
  </div>
</template>

<script>
import $ from 'jquery';
import * as moment from 'moment';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import WarningPopup from '../UIComponents/WarningPopup.vue';
import { getUserData, getProfileData } from '../../apis/profile';
import { getAddonDetails } from '../../apis/psm';
import {
  getTeamMemberRestrictedUsersCount, confirmCancelSubscription, renewSubscription, getPendingNewProducts,
} from '../../apis/team';
import {
  isAllCountriesSelected,
  getAvailableRegIntelCountries,
} from '../../apis/regulatoryIntelligence';
import UpdateService from './UpdateService.vue';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';
import { getSubscriptions } from '../../apis/registrations';
import { getPurchaseDetails } from '../../apis/marketPlace';

export default {
  mixins: [permissionsList],
  components: {
    Loader,
    WarningPopup,
    UpdateService,
  },
  props: ['roleId', 'roleInfo'],
  data() {
    return {
      regIntellMarket: '',
      isDefaultMarket: false,
      allMarketsSelected: false,
      countries: [],
      viewMore: true,
      loaderStatus: false,
      services: [],
      planList: [],
      teamMember: {},
      records: {},
      storage: {},
      addonType: '',
      isREP: false,
      selectedService: {},
      recordPrice: 0,
      teamPrice: 0,
      teamLimit: 0,
      prodClassUtil: {},
      regPathwayUtil: {},
      rationaleRepUtil: {},
      rationaleRepEmergoUtil: {},
      expiryServicesList: [],
      expiryAddOnList: [],
      renewedServicesList: [],
      renewedAddonList: [],
      regIntelPrice: 0,
      restrictedUsersCount: 0,
      accountId: null,
      projectsList: [],
      updateServiceFlag: false,
      new_services: [this.$i18n.locale === 'Portuguese' ? 'Rastreador de Conformidade' : 'Compliance Tracker', this.$i18n.locale === 'Portuguese' ? 'Recursos' : 'Resources'],
      warningPopupId: 'cancelSubscription',
      confirmMessage: '',
      customMessage: '',
      productMessage: '',
      permissions: [],
      subscriptions: [],
      pendingProducts: [],
      pendingNames: [],
      pendingIds: [],
      purchaseDetails: ''
    };
  },
  computed: {
    displayCountries() {
      if (this.viewMore && this.countries.length > 5) {
        return this.countries.slice(0, 5);
      }
      return this.countries;
    },
    displayRenewAll() {
      if (this.planList.length) {
        return this.planList.filter((service) => {
          const response = this.expiryServicesList.find((o) => o.name === service.name);
          return (response && response.expiry_date && service.service_type === 'premium' && !service.renewed && (service.id === 1 || service.id === 2 || service.id === 4 || service.id === 6));
        }).length > 1;
      }
      return false;
    },
  },
  methods: {
    async getPurchaseInfo() {
      this.loaderStatus = true;
      const response = await getPurchaseDetails();
      this.purchaseDetails = response.find((item) => item.subscriptionId === 2);
      this.loaderStatus = false;
    },
    async validateFeatures() {
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS', 'REG_TRACKER_REPORTS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
    },
    async cancelUpdateAccount() {
      this.loaderStatus = true;
      await this.getAddonDetails();
      this.loaderStatus = false;
      this.updateServiceFlag = false;
      this.$emit('emitBreadCrumb', false);
    },
    todayDate() {
      return moment()
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');
    },
    goToMarketPlace() {
      this.$emit('closepopup', 'closeBasePopup');
      this.$router.push('/layout/market-place');
    },
    async getAddedServiceDetails() {
      this.loaderStatus = true;
      await this.getAddonDetails();
      // this.loaderStatus = false;
    },
    async getAddonDetails() {
      this.addonDetails = await getAddonDetails(
        this.accountId,
      );
      const index = this.addonDetails.findIndex(
        (addon) => addon.units === 'RECORDS',
      );
      if (index >= 0) {
        this.records = this.addonDetails[index];
        const totalLimit = this.records.total_limit;
        if (totalLimit <= 250) {
          this.recordPrice = 0;
        } else if (totalLimit > 250 && totalLimit <= 1000) {
          this.recordPrice = 200;
        } else if (totalLimit > 1000 && totalLimit <= 2000) {
          this.recordPrice = 300;
        } else if (totalLimit > 2000 && totalLimit <= 3000) {
          this.recordPrice = 400;
        } else if (totalLimit > 3000 && totalLimit <= 4000) {
          this.recordPrice = 500;
        } else if (totalLimit > 4000 && totalLimit <= 5000) {
          this.recordPrice = 600;
        }
      }
      const storageIndex = this.addonDetails.findIndex(
        (addon) => addon.units === 'STORAGE',
      );
      if (index >= 0) {
        this.storage = this.addonDetails[storageIndex];
      }
      const teamIndex = this.addonDetails.findIndex(
        (addon) => addon.units === 'USERS',
      );
      if (teamIndex >= 0) {
        this.teamMember = this.addonDetails[teamIndex];
        const response = this.expiryAddOnList.find((o) => o.name === 'Team members');
        if (response) {
          this.teamMember.expiry_date = response.expiry_date;
        }
        const res = this.renewedAddonList.find((o) => o === 1);
        if (res) {
          this.teamMember.renewed = true;
        }
        // if ((this.teamMember.total_limit > this.teamMember.default_limit) && this.teamMember.is_active && this.todayDate() < this.teamMember.valid_until && this.todayDate() >= this.teamMember.valid_from) {
        if (this.isREP) {
          this.teamLimit = this.teamMember.total_limit - 1;
        } else {
          this.teamLimit = this.teamMember.total_limit;
        }
        // } else {
        //   this.teamLimit = this.teamMember.default_limit;
        // }
        if (this.teamLimit <= 5) {
          this.teamPrice = 0;
        } else if (this.teamLimit <= 10) {
          this.teamPrice = (this.teamLimit - 5) * 100;
        } else if (this.teamLimit > 10 && this.teamLimit <= 25) {
          this.teamPrice = 5 * 100 + (this.teamLimit - 10) * 50;
        }
      }
      this.prodClassUtil = this.addonDetails[this.addonDetails.findIndex(
        (addon) => addon.id === 5,
      )];
      this.regPathwayUtil = this.addonDetails[this.addonDetails.findIndex(
        (addon) => addon.id === 9,
      )];
      this.rationaleRepUtil = this.addonDetails[this.addonDetails.findIndex(
        (addon) => addon.id === 6,
      )];
      this.rationaleRepEmergoUtil = this.addonDetails[this.addonDetails.findIndex(
        (addon) => addon.id === 7,
      )];
      this.restrictedUsersCount = await getTeamMemberRestrictedUsersCount(this.accountId);
    },
    regIntelvalidUntil() {
      const index = this.addonDetails.findIndex(
        (addon) => addon.units === 'COUNTRIES',
      );
      if (index >= 0) {
        return moment.utc(this.addonDetails[index].valid_until).format('YYYY-MM-DD HH:mm:ss');
      }
      return null;
    },
    renewDate() {
      return moment
        .utc('12/31/2021')
        .format('YYYY-MM-DD HH:mm:ss');
    },
    async isAllCountriesSelected() {
      this.allMarketsSelected = await isAllCountriesSelected(
        11,
        this.accountId,
      );
      if (this.allMarketsSelected) {
        this.regIntellMarket = 'all';
        this.regIntelPrice = 499;
      } else {
        this.regIntellMarket = 'multiple';
        const selectedIds = await getAvailableRegIntelCountries(this.accountId);
        const newList = [];
        let countryData = '';
        selectedIds.forEach((c) => {
          countryData = this.allCountryList.find((each) => each.country_id === c);
          if (countryData) {
            newList.push(countryData);
          }
        });
        this.countries = newList.map((a) => a.country_name);
        this.regIntelPrice = (this.countries.length) * 99;
      }
    },
    upgradeService(service, type) {
      this.selectedService = service;
      this.addonType = type;
      this.updateServiceFlag = true;
      this.$emit('emitBreadCrumb', 'Update Service');
    },
    SBRenewalPopup(service) {
      this.selectedService = service;
    },
    cancelService(service) {
      this.selectedService = service;
    },
    async payForService(service) {
      this.$emit('closepopup', 'closeBasePopup');
      const profileData = localStorage.getItem('profileData') ? JSON.parse(localStorage.getItem('profileData')) : await getProfileData();
      const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : await getUserData();
      if (userData.id === profileData.id) {
        if (service.id === 8) {
          this.$router.push('/layout/market-place/add-service/7');
        } else if (service.id === 9 || service.id === 10) {
          const params = { serviceId: 6, serviceIdsToDisplay: [7, 9, 10], defaultSelectedService: service.id };
          this.$router.push({ name: 'addService', params });
        } else if (service.id === 12) {
          const params = { serviceId: 6, serviceIdsToDisplay: [7, 12], defaultSelectedService: 12 };
          this.$router.push({ name: 'addService', params });
        } else {
          this.$router.push(`/layout/market-place/add-service/${service.id}`);
        }
      } else {
        this.$router.push('/layout/dashboard');
      }
    },
    async renewService(service) {
      this.$emit('closepopup', 'closeBasePopup');
      const profileData = localStorage.getItem('profileData') ? JSON.parse(localStorage.getItem('profileData')) : await getProfileData();
      const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : await getUserData();
      if (userData.id === profileData.id) {
        if (this.$route.path === '/layout/market-place/renew-service') EventBus.$emit('renewServiceIds', [service.id]);
        else this.$router.push({ name: 'renewService', params: { serviceIds: [service.id] } });
      } else {
        this.$router.push('/layout/dashboard');
      }
    },
    renewExpiringServices() {
      const serviceIds = this.planList
        .filter((service) => service.service_type === 'premium' && service.expiry_date && (service.id === 1 || service.id === 2 || service.id === 4 || service.id === 6))
        .map((each) => each.id);
      this.$emit('closepopup', 'closeBasePopup');
      if (this.$route.path === '/layout/market-place/renew-service') EventBus.$emit('renewServiceIds', serviceIds);
      else this.$router.push({ name: 'renewService', params: { serviceIds } });
    },
    getExpiringProjectsCount() {
      return this.projectsList.filter((p) => moment(p.expiresAt).isSameOrAfter(moment(), 'day')).length;
    },
    async cancelSubscription() {
      const response = await getPendingNewProducts();
      this.pendingProducts = response;
      this.pendingNames = (this.pendingProducts.map((obj) => obj.product_name)).toString();
      this.customMessage = this.$i18n.locale === 'Portuguese' ? 'Ao cancelar, você não poderá mais usufruir dos serviços PRO do Rastreador de conformidade.' : 'By cancelling, you can no longer avail the PRO services of Compliance Tracker.';
      this.productMessage = this.$i18n.locale === 'Portuguese' ? `Seus registros incompletos ${this.pendingNames} serão removidos do sistema após o cancelamento.` : `Your Incomplete records ${this.pendingNames} will be removed from the system on cancellation.`;
      this.confirmMessage = this.$i18n.locale === 'Portuguese' ? 'Você ainda deseja cancelar?' : 'Do you still want to cancel?';
      $(`#${this.warningPopupId}`).modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    async confirmCancel() {
      this.loaderStatus = true;
      this.pendingIds = (this.pendingProducts.map((obj) => obj.registration_id)).toString();
      const response = await confirmCancelSubscription(this.pendingIds);
      if (response.status_code === 200) {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: response.message,
          group: 'custom-notification',
        });
        this.subscriptions = await getSubscriptions(true);
        this.$router.push('/layout/market-place');
        this.$router.go();
      }
    },
    async renewSubscription() {
      this.loaderStatus = true;
      const response = await renewSubscription();
      if (response.status_code === 200) {
        this.loaderStatus = false;
        if (response.is_redirect_to_market === false) {
          this.clearNotifcations();
          this.$notify({
            type: 'success',
            title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
            text: response.message,
            group: 'custom-notification',
          });
          this.subscriptions = await getSubscriptions(true);
          this.$router.push('/layout/market-place');
          this.$router.go();
        } else {
          this.$router.push('/layout/market-place');
        }
      } else {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'A renovação da assinatura falhou!' : 'Subscription renewal failed!',
          group: 'custom-notification',
        });
      }
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
  },
  filters: {
    dateFormat(date) {
      return localStorage.getItem('language') === 'Portuguese' ? moment(date).format('DD/MM/YYYY') : moment(date).format('MM/DD/YYYY');
    },
  },
  async mounted() {
    this.isREP = JSON.parse(localStorage.getItem('userData')).account_type_id === 2 || JSON.parse(localStorage.getItem('userData')).account_type_id === 4;
    this.accountId = JSON.parse(localStorage.getItem('userData')).account_id ? JSON.parse(localStorage.getItem('userData')).account_id : await getUserData();
    await this.getAddedServiceDetails();
    await this.validateFeatures();
    this.subscriptions = await getSubscriptions(true);
    await this.getPurchaseInfo();
  },
};
</script>

<style scoped>
.multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
}
.product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
  margin-bottom: 0px;
}
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 44px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 44px;
    padding: 9px 40px 11px 11px;
    /* border: 1px solid #4D4D4D !important; */
    border: 1px solid #4D4D4D !important;
    /* border: 1px solid #CCCCCC !important; */
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 11px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top:8px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
        /* border: 1px solid #4D4D4D; */

  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    /* border: 1px solid #000000;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg); */
    /* border: 1px solid #0b3c61; */
    /* border-width: 0 1px 1px 0; */
    /* display: inline-block; */
    /* padding: 5px; */
    /* top: 0px;
    content: "";
    border-width: 7px 7px 0;
    padding: 0px !important; */
    position: relative;
    right: 0;
    /* top: 65%; */
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    /* -webkit-transform: rotate(45deg); */
    /* border: 1px solid #0b3c61;
    border-width: 0 2px 2px 0;
    display: inline-block; */
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    /* background: #e6e6e6 !important; */
    /* font-weight: 600 !important; */
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected span{
    /* font-weight: 600 !important; */
  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999999;
    overflow: visible;
    /* padding:7px 0px 7px 12px; */
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important
  }
   /* .multiselect-single-dropdown input::placeholder{
    color: red;
   } */
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    /* border: 1px solid black; */
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    /* border-radius:3px !important; */
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
.update-account-button, .update-account-button:hover {
  border-radius: 3px;
  background: #E6E6E6;
  padding: 7px 16px;
  color: #404040;
  font-size: 16px;
  font-weight: 600;
  margin-top: 6px;
}
.pb-100 {
  padding-bottom: 100px;
}
.my-services {
  padding-top: 21px;
  padding-left: 34px;
  font-size: 18px;
  line-height: 33px;
  color: #333333;
  font-weight: 600;
}
.my-services-account {
  padding: 43px 0 0px 46px;
  color: #333333;
  font-size: 16px;
  font-weight: 700;
}
.add_icon_img {
  padding-bottom: 3px;
}
.fnt_14{
  font-size: 14px;
}
.help-text {
  color: #01518A;
}
.alert-image{
  background-image: url(/static/images/icons/alert_triangle.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 50px;
  height: 57px;
  position: relative;
  background-size: 40px;
}
.position-relative {
  position: relative;
}
.min_hght_32 {
  min-height: 32px;
}
.min-ht-100 {
  min-height: 100px;
}
.renew-class {
  color: #00518a;
  position: absolute;
  right: 45px;
  top: -4px;
  text-align: center;
}
.renew-class-2 {
  top: -35px;
}
.top_28 {
  top: 28px;
}
.pr-40 {
  padding-right: 40px !important;
}
.display-flex{
  display: -webkit-box;
  align-items: center;
}
.ft-16{
  font-size:16px;
}
.pt-10 {
  padding-top: 10px;
}
.cust-link {
  margin-top: 5px;
  color: #2f80ed;
  font-size: 14px;
  cursor: pointer;
}
.market_place_img {
  width: 18%;
  margin-top: 7%;
}
.ml-5 {
  margin-left: 5px;
}
.m-0 {
  margin: 0;
}
.pl-25 {
  padding-left: 25px;
}
.p-0 {
  padding: 0;
}
.main-add-services {
  top: 54px;
  right: 47px;
  position: absolute;
}
img.success_logo.card-img-top {
    width: 30px;
    height: 30px;
    background-color: #00518a;
    border-radius: 50%;
    padding: 6px;
}
.cancel-services,
.upgrade-service,
.renew-service {
  text-align: end;
  margin-right: 41px;
}
.upgrade-service {
  margin-bottom: 20px;
  margin-top: 1px;
}
.cancel-services {
  color: #00518a;
  cursor: pointer;
  /* margin-right: 45px; */
}
.dollar-year {
  text-align: end;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
}
.box-wrapper {
  overflow-y: auto;
  /* max-height: calc( 84vh - 100px ); */
  overflow-x: hidden;
  padding-bottom: 100px;
  padding: 0px;
}
ul.regulatory-intelligence {
  list-style: none;
  padding-left: 0px;
}
.box-wrapper hr.upper-line {
  margin: 16px 0px 0px 0px;
  border-top: 1px solid #D3D3D3;
  opacity: 0.4;
}
.box-wrapper hr.upper-line-records {
  margin: 9px 32px 13px 53px;
}
hr.lower-line {
  margin: 15px 32px 16px 46px;
  border-top: 1px solid #D3D3D3;
}

.team-member-reg {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  padding-bottom: 4px;
}
span.available-item {
  font-size: 16px;
  color: #333333;
}
span.total-record {
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
}
.reg-tracker-service {
  font-size: 20px;
  text-align: center;
  color: #000000;
  padding-top: 10px;
}
.confirm-body .reg-tracker-para {
  padding-bottom: 5px;
}
/* .acct-service {
  font-weight: 300;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
  padding-left: 10px;
} */
.team-members {
  padding-left: 54px;
}
.available-upto {
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}
.check-icon {
  padding-left: 20px;
  width: 17px;
  height: 17px;
}
.free-renews {
  padding-top: 9px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  line-height: 19px;
}
.country_list {
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
}
.mb-5 {
  margin-bottom: 5px;
}
.upper-line-services {
  margin-top: 12px;
  margin-left: 48px;
  margin-right: 15px;
  border-top: 0.7px solid #BDBDBD;
}
.reg-records,
.free-service-renews {
  padding-left: 25px;
}
.pt-20 {
  padding-top: 20px;
}
@media only screen and (max-width: 767px) {
  .renew-class {
    right: 15px;
  }
  .free-renews {
    padding-bottom: 15px;
  }
  .ml-5{
    margin-left: -15px;
  }
  .main-add-services {
    right: 15px;
  }
  .upgrade-service-btn{
    text-align: start;
  }
  .upgrade-service,
  .renew-service,
  .upper-line-services,
  .cancel-services {
    margin-right: 0px;
  }
  ul.regulatory-intelligence {
    padding-left: 0px;
  }
  .acct-service {
    padding-top: 12px;
    padding-left: 12px;
    font-weight: 400;
    font-size: 20px;
    line-height: 27px;
    color: #333333;
  }
  .box-wrapper hr.upper-line {
    margin-right: 0px;
    margin-top: 10px;
  }
  .dollar-year {
    text-align: center;
  }
  .box-wrapper .reg-tracker {
    margin-left: 0px;
  }
}
@media (min-width: 767px) and (max-width: 1024px) {
  .box-wrapper {
    max-height: 46vh;
  }
}
@media screen and (width: 768px) {
  .box-wrapper {
    max-height: 52vh;
  }
}
@media (min-width: 1422px) and (max-width: 1599px) {
  .free-service-renews {
    padding-left: 15px;
  }
  .reg-records {
    padding-left: 15px;
  }
}
@media only screen and (min-width: 1600px) {
  .free-service-renews {
    padding-left: 4px;
  }
  .reg-records {
    padding-left: 4px;
  }
}
/* Modal */
.modal-header .close {
  background: none;
  opacity: 0.5;
  height: 17px;
  line-height: 17px;
  color: #828282;
  width: 17px;
  border-radius: 20px;
  font-weight: 300;
  outline: none;
  font-size: 32px;
}
.modal-header.cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.confirm-body {
  padding: 5% 12%;
  margin-bottom: 10%;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}
.modal-footer.cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.modal-footer.cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.submit-btn {
  background: #0b3c61;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  color: #f2f2f2;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  padding: 7px 41px 11px;
}
.upgrade-service a,
.cancel-services a {
  cursor: pointer;
}

.modal-content.first-modal-content {
  border-radius: 12px;
}
.cancel-service-para {
  font-size: 18px;
  text-align: center;
  color: #000000;
  padding-top: 10px;
}
.reg-intelligence-para {
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #0b3c61;
  padding-top: 10px;
}
.modal-body-para {
  padding: 5px 55px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #828282;
}
.current-service {
  background: #0b3c61;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  color: #f2f2f2;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  padding: 8px 38px;
}
.please-cancel {
  background: #fff;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  color: #0b3c61;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  padding: 8px 60px;
}
.modal-footer.cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 32px;
}

.modal-title.service-modal-title {
  text-align: center;
}
.cancel-successful {
  padding-top: 16px;
  font-weight: 500;
  font-size: 28px;
  line-height: 33px;
  color: #4c9e45;
}
.process-cancel {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #828282;
  padding-top: 16px;
}
.scnd-modal-service {
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #133d5f;
}
.process-hr-line {
  margin-bottom: 0px;
}
.modal-header.scnd-cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 0px;
}
.scnd-service-para {
  padding: 6px 121px;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}
.textarea-field {
  text-align: center;
}
.textarea-field textarea {
  background: #ffffff;
  border: 0.5px solid #828282;
  box-sizing: border-box;
  border-radius: 7px;
}
div#cancelModal {
  background-color: rgba(0, 0, 0, 0.5);
}
div#scnd-cancelModal {
  background-color: rgba(0, 0, 0, 0.9);
}
/* upgrade modal */
div#upgradeModal {
  background-color: rgba(0, 0, 0, 0.5);
}
div#ConfirmationModal {
  background-color: rgba(0, 0, 0, 0.6);
}
.modal-header.upgradeModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.upgrade-service-para {
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #0b3c61;
  padding-top: 10px;
}
.reg-tracker-para {
  font-size: 18px;
  text-align: center;
  color: #000000;
  padding-top: 10px;
}
p.inline-service {
  display: inline;
}
.traingle-alert {
  margin-right: 10px;
  width: 20px;
  vertical-align: bottom;
}
.expiration-title {
  color:#B00505;
  vertical-align: bottom;
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px){
  .box-wrapper {
    max-height: 60vh;
    padding-bottom: 11px
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px){
  .box-wrapper {
    max-height: 55vh;
    padding-bottom: 11px
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px), (device-width: 667px) and (device-height: 375px){
  .box-wrapper {
    max-height: 60vh;
    padding-bottom: 11px
  }
}
.alert-image .tooltiptext {
  visibility: hidden;
  width: 351px;
  background-color: #F2F2F2;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
  border-radius: 10px;
  padding: 16px;
  position: absolute;
  z-index: 1;
  top: 3.8em;
  left: -1em;
  margin-left: -60%;
  opacity: 0;
  transition: opacity 1s;
  box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.5);
  font-size: 18px;
  line-height: 21px;
  font-weight: 400;
  text-align: left;
  word-break: break-word;
}
.alert-image:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.alert-image .tooltiptext::after {
  display: unset;
  position: absolute;
  pointer-events: none;
  content: "";
  transform: rotate(45deg);
  width: 1em;
  height: 1em;
  background: #F2F2F2;
  z-index: -10;
  top: -0.4em;
  left: 3.4em;
  box-shadow: none;
  margin: auto;
}
.team-member-limit {
  font-size: 16px;
  color: #333333;
}
.services{
  font-weight: 700;
  font-size: 16px;
  color: #333;
  padding-left: 45px;
  padding-top:50px;
}
.services-line {
  margin: 15px 32px 2px 46px;
  border-top: 1px solid #D3D3D3;
}
.service-name {
  padding-left: 10px;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
}
.box-wrapper::-webkit-scrollbar {
  width: 6px;
  /* max-height: 50%;
  height: 50%; */
}

.box-wrapper::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  /* height: 30%; */
}

.main-services {
  padding-right: 0px;
}

.complianceTracker .greenCheckMark .img {
  width: 18px;
  height: 18px;
}

.complianceTracker {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 52px;
  /* padding:0px; */
}

.complianceTracker .greenCheckMark {
  display: flex;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 15px;
}

.complianceTracker .complianceTrackerCarret {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.complianceTracker .complianceTrackerText {
  margin-left: 9px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0px;
  margin-top: 0px;
  color: #333;
}
.cancel-sub {
  color: #01518A;
  font-size: 14px;
  float: right;
  margin-top: 15px;
  margin-right: 70px;
  cursor: pointer;
}

</style>
